import { Component, OnInit, Input, SimpleChange, Output, EventEmitter, TemplateRef, ViewChild, SimpleChanges } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonMethodService } from '../common-method.service';
import { ProspectService } from 'src/app/services/operations/prospects.service';
@Component({
    selector: 'app-merchandiseShared',
    templateUrl: 'merchandise.shared.component.html',
    styleUrls: ['merchandise.shared.component.scss'],
    standalone: false
})
export class MerchandiseSharedComponent implements OnInit {
  @Input() moduleType;
  @Input() MerchandiseList;
  @Input() defaultMerchandiseConfig;
  @Input() activeMerchandiseList;
  @Output() emitExistingMerchandise = new EventEmitter();
  @Output() emitisDirtyMerchShared = new EventEmitter();
  @Output() emitMerchandiseList = new EventEmitter();
  @Output() emitLoaderIconChange = new EventEmitter();
  @ViewChild('discountModalPopup', { static: true }) discountModalPopup: TemplateRef<any>;
  modalRef: BsModalRef;
  masterMerchandiseList = [];
  masterMerchandiseListForFilter = [];
  hasPendingDefaults = false;
  moduleReservation = false;
  currentDiscountId: any;
  currentDiscountMercType: any;
  merchandiseDiscountList: any;
  masterMerchandiseDiscountList: any;
  priproCheckSaveDisable = true;
  filterMerchandiseName = '';
  filterStock = '';
  filterQty = '';
  filterDiscount = '';
  filterPrice = '';
  constructor(private cp: CurrencyPipe,
    private modalService: BsModalService,
    private commonMethodService: CommonMethodService,
    private prospectService: ProspectService) { }

  ngOnInit() {
    if (this.moduleType === 'reservation') {
      this.moduleReservation = true;
    }
    if (this.activeMerchandiseList && this.activeMerchandiseList.length !== 0) {
      this.checkActiveList();
    }
  }

  async ngOnChanges(changes: SimpleChanges) {
    const merchandiseChanged = changes['MerchandiseList'];
    const configChanged = changes['defaultMerchandiseConfig'];

    if (merchandiseChanged?.currentValue !== merchandiseChanged?.previousValue) {
      this.masterMerchandiseList = merchandiseChanged?.currentValue
        ? [...merchandiseChanged.currentValue]
        : [];
      this.masterMerchandiseListForFilter = [...this.masterMerchandiseList];
    }

    if (configChanged && configChanged.currentValue !== configChanged.previousValue) {
      this.hasPendingDefaults = true;
    }

    const listReady = this.masterMerchandiseList?.length > 0;
    const configReady = this.defaultMerchandiseConfig?.length > 0;

    if (listReady && configReady && this.hasPendingDefaults) {
      await this.applyDefaultMerchandise();
      this.checkActiveList();

      this.masterMerchandiseList = this.masterMerchandiseList.map(x => ({ ...x }));
      this.masterMerchandiseListForFilter = this.masterMerchandiseListForFilter.map(x => ({ ...x }));

      this.activeMerchandiseList = this.MerchandiseList.filter(ele => ele.selected);
      this.emitExistingMerchandise.emit('DEFAULT_MERCHANDISE_APPLIED');
      this.hasPendingDefaults = false;
    }
  }

  private async applyDefaultMerchandise() {
    for (const config of this.defaultMerchandiseConfig) {
      const item = this.MerchandiseList.find(m =>
        m.Id === config.MerchandiseId && m.MerchandiseType === config.Type
      );
      if (item) {
        if (item.InStock < config.MerchandiseQuantity) {
          continue;
        }
        const originalStock = item.InStock;
        const limiter = item.InStock;
        item.selected = true;
        item.isDefaultLocked = true;
        item.Quantity = config.MerchandiseQuantity;
        item.originalInStock = originalStock;
        if (!this.moduleReservation) {
          item.InStock = limiter - config.MerchandiseQuantity;
        }
        if (item.MerchandiseDiscount?.length) {
          const discounts = item.MerchandiseDiscount;
          const selectedIds = new Set(
            discounts
              .filter(d => d.Selected)
              .map(d => d.Id)
          );
          if (config.MerchandiseDiscountId) {
            const exists = discounts.some(
              d => d.Id == config.MerchandiseDiscountId
            );
            if (exists) {
              selectedIds.add(config.MerchandiseDiscountId);
            }
          }

          discounts.forEach(d => {
            d.Selected = selectedIds.has(d.Id);
            d.isDefaultLocked = selectedIds.has(d.Id);
          });

          item.selectedDiscount = Array.from(selectedIds);
        }
        if (config.WaiveCost) {
          item.TenantPrice = 0;
          item.TenantPiceTax = 0;
          item.SalesPrice = 0;
          item.WaiveCost = !!config.WaiveCost;
          continue;
        }
        if (!config.WaiveCost && config.TenantPrice > 0) {
          item.TenantPrice = config.TenantPrice;
          item.CostPrice = config.TenantPrice;
          item.SalesPrice = config.TenantPrice;
        }
        if (!item.TenantPrice && item.ItemCost) {
          item.TenantPrice = item.ItemCost;
        }

        this.calculateMerchandiseDiscount(item);
        await this.calculateMerchandiseTotal([item]);
      }
    }
  }

  checkActiveList() {
    if (this.activeMerchandiseList) {
      this.activeMerchandiseList.map((ele) => {
        let obj = this.MerchandiseList.find(o => o.Id === ele.Id && o.MerchandiseType == ele.MerchandiseType);
        if (obj) {
          obj.selected = true;
          obj.Quantity = ele.Quantity;
          obj.DiscountAmount = ele.originaldiscountamount;
          obj.DiscountFilterName = ele.DiscountFilterName;
          obj.DiscountName = ele.DiscountName;
          let selectedDiscounts = ele.MerchandiseDiscount.filter((item) => item.Selected == true);
          if (selectedDiscounts.length) {
            selectedDiscounts.map((dItem) => {
              let discObj = obj.MerchandiseDiscount.find(d => d.Id == dItem.Id)
              if (discObj) {
                discObj.Selected = true;
              }
            })
          }
        }
      });
    }
    this.emitExistingMerchandise.emit('0');
  }

  quantityChange(val, marcId, marcCode) {
    this.emitLoaderIconChange.emit(true);
    const limiter = this.masterMerchandiseList.find(o => o.Id === marcId && o.Code === marcCode).InStock;
    let merchandise = this.MerchandiseList.find(o => o.Id === marcId && o.Code === marcCode);
    if (parseInt(val) > limiter) {
      merchandise.Quantity = limiter;
      merchandise.InStock = 0;
    } else {
      merchandise.InStock = limiter;
      merchandise.InStock -= parseInt(merchandise.Quantity);
    }
    if (val == null || val === '') {
      merchandise.Quantity = 0;
      merchandise.InStock = limiter;
    }

    if (this.moduleReservation) {
      merchandise.Quantity = parseInt(val);
    }
    if (parseInt(val) === 0) {
      merchandise.selected = false;
    }
    this.calculateMerchandiseDiscount(merchandise);
    this.emitisDirtyMerchShared.emit(true);

    this.MerchandiseList.map(ele => {
      let index = this.masterMerchandiseListForFilter.findIndex(o => o.Id === ele.Id && o.MerchandiseType === ele.MerchandiseType);
      if (index != -1) {
        this.masterMerchandiseListForFilter[index] = ele;
      }
    });
    this.emitLoaderIconChange.emit(false);
  }

  addQuantity(marcId, marcCode) {
    this.emitLoaderIconChange.emit(true);
    const limiter = this.masterMerchandiseList.find(o => o.Id === marcId && o.Code === marcCode).InStock;
    let merchandise = this.MerchandiseList.find(o => o.Id === marcId && o.Code === marcCode);
    if (parseInt(merchandise.Quantity) < limiter) {
      merchandise.Quantity++;
      if (!this.moduleReservation) {
        merchandise.InStock--;
      }
    }
    this.calculateMerchandiseDiscount(merchandise);
    this.emitisDirtyMerchShared.emit(true);

    this.MerchandiseList.map(ele => {
      let index = this.masterMerchandiseListForFilter.findIndex(o => o.Id === ele.Id && o.MerchandiseType === ele.MerchandiseType);
      if (index != -1) {
        this.masterMerchandiseListForFilter[index] = ele;
      }
    });
    this.emitLoaderIconChange.emit(false);
  }

  merchandiseSelect(data, merchId, merchType) {
    this.emitisDirtyMerchShared.emit(true);
    const limiter = this.masterMerchandiseList.find(o => o.Id === merchId && o.MerchandiseType === merchType).InStock;
    let merchandise = this.MerchandiseList.find(o => o.Id === merchId && o.MerchandiseType === merchType);
    if (parseInt(merchandise.Quantity) === 0) {
      merchandise.Quantity++;
      if (!this.moduleReservation) {
        merchandise.InStock--;
      }
      this.calculateMerchandiseDiscount(merchandise);
    }
    if (!data) {
      if (!this.moduleReservation) {
        merchandise.InStock = limiter;
      }
      merchandise.Quantity = 0;
      merchandise.DiscountAmount = 0;
      merchandise.MerchandiseDiscount.forEach(d => {
        if (!d.ApplyAutomatically) {
          d.Selected = false;
        }
      });
      let count = merchandise.MerchandiseDiscount.filter((ele) => ele.Selected === true);
      if (count.length === 0) {
        merchandise.DiscountName = 'None';
      } else if (count.length === 1) {
        merchandise.DiscountName = merchandise.MerchandiseDiscount.find(o => o.Selected === true).Name + ' ' + '- (' + this.cp.transform(merchandise.DiscountAmount) + ')';
      } else {
        merchandise.DiscountName = 'Multiple ' + '- (' + this.cp.transform(merchandise.DiscountAmount) + ')';
      }
    }

    this.MerchandiseList.map(ele => {
      let index = this.masterMerchandiseListForFilter.findIndex(o => o.Id === ele.Id && o.MerchandiseType === ele.MerchandiseType);
      if (index != -1) {
        this.masterMerchandiseListForFilter[index] = ele;
      }
    });
    this.emitMerchandiseList.emit(this.masterMerchandiseListForFilter);
  }

  removeQuantity(marcId, marcCode) {
    this.emitLoaderIconChange.emit(true);
    let merchandise = this.MerchandiseList.find(o => o.Id === marcId && o.Code === marcCode);
    if (parseInt(merchandise.Quantity) !== 0) {
      merchandise.Quantity--;
      if (!this.moduleReservation) {
        merchandise.InStock++;
      }
      if (parseInt(merchandise.Quantity) === 0) {
        merchandise.selected = false;
      }
    }
    this.calculateMerchandiseDiscount(merchandise);
    this.emitisDirtyMerchShared.emit(true);

    this.MerchandiseList.map(ele => {
      let index = this.masterMerchandiseListForFilter.findIndex(o => o.Id === ele.Id && o.MerchandiseType === ele.MerchandiseType);
      if (index != -1) {
        this.masterMerchandiseListForFilter[index] = ele;
      }
    });
    this.emitLoaderIconChange.emit(false);
  }

  discpopCheckChange() {
    this.emitisDirtyMerchShared.emit(true);
    this.priproCheckSaveDisable = false;
  }

  populateDiscountPopup(merId, merType) {
    let newObj = this.MerchandiseList.find(o => o.Id === merId && o.MerchandiseType === merType);
    this.currentDiscountId = newObj.Id;
    this.currentDiscountMercType = newObj.MerchandiseType;
    this.merchandiseDiscountList = newObj.MerchandiseDiscount;
    this.masterMerchandiseDiscountList = JSON.parse(JSON.stringify(newObj.MerchandiseDiscount));
    this.openModal(this.discountModalPopup);
    this.priproCheckSaveDisable = true;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: "modal-dialog-centered", backdrop: 'static', keyboard: false });
  }

  applyDiscount() {
    this.emitLoaderIconChange.emit(true);
    let newObj = this.MerchandiseList.find(o => o.Id === this.currentDiscountId && o.MerchandiseType === this.currentDiscountMercType);
    this.calculateMerchandiseDiscount(newObj);
    this.modalRef.hide();
    this.masterMerchandiseListForFilter = JSON.parse(JSON.stringify(this.MerchandiseList));
    this.emitLoaderIconChange.emit(false);
  }

  calculateMerchandiseDiscount(merchandiseObj) {
    merchandiseObj.DiscountAmount = 0;
    merchandiseObj.DiscountFilterName = '';
    this.commonMethodService.calculateMercDiscount(merchandiseObj, 'Sale');
    let count = merchandiseObj.MerchandiseDiscount.filter((ele) => ele.Selected === true);
    if (count.length === 0) {
      merchandiseObj.DiscountName = 'None';
    } else if (count.length === 1) {
      merchandiseObj.DiscountName = merchandiseObj.MerchandiseDiscount.find(o => o.Selected === true).Name + ' ' + '- (' + this.cp.transform(merchandiseObj.DiscountAmount) + ')';
    } else {
      merchandiseObj.DiscountName = 'Multiple ' + '- (' + this.cp.transform(merchandiseObj.DiscountAmount) + ')';
    }
  }

  async saveMerchandise(eve) {
    this.filterMerchandiseName = '';
    this.MerchandiseList = JSON.parse(JSON.stringify(this.masterMerchandiseListForFilter));
    this.activeMerchandiseList = this.MerchandiseList.filter((ele) => ele.selected);
    await this.calculateMerchandiseTotal(
      this.MerchandiseList.filter(x => x.selected)
    );
    this.MerchandiseList = [...this.MerchandiseList];

    this.masterMerchandiseListForFilter = JSON.parse(JSON.stringify(this.MerchandiseList));
    if (eve === '') {
      this.emitisDirtyMerchShared.emit(false);
    }
  }

  cancelMerchandise() {
    this.MerchandiseList = JSON.parse(JSON.stringify(this.masterMerchandiseListForFilter));
    this.emitisDirtyMerchShared.emit(false);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  async calculateMerchandiseTotal(arr) {
    await Promise.all(arr.map(async (item): Promise<any> => {
      const tempTotalAmount = this.calculatePriceAndDiscountAmt(item);
      item.TenantPiceTax = await this.commonMethodService.getTaxValue(item.MerchandiseTaxes, tempTotalAmount);
      return item;
    }));
    return arr;
  }

  calculatePriceAndDiscountAmt(merchObj) {
    const price = merchObj.Quantity * merchObj.SalesPrice;
    merchObj.TotalAmount = Math.max(0, price - merchObj.DiscountAmount);
    return merchObj.TotalAmount;
  }

  cancelDiscount() {
    let newObj = this.MerchandiseList.find(o => o.Id === this.currentDiscountId && o.MerchandiseType === this.currentDiscountMercType);
    newObj.MerchandiseDiscount = JSON.parse(JSON.stringify(this.masterMerchandiseDiscountList));
    this.modalRef.hide();
  }

  filterTable(data) {
    this.MerchandiseList = JSON.parse(JSON.stringify(this.masterMerchandiseListForFilter));

    if (this.filterMerchandiseName !== '') {
      this.MerchandiseList = this.MerchandiseList.filter((ele) => ele.Name.toLowerCase().indexOf(this.filterMerchandiseName.toLowerCase()) !== -1);
    }

    if (this.filterStock !== '') {
      this.MerchandiseList = this.MerchandiseList.filter((ele) => ele.InStock.toString().indexOf(this.filterStock.toString()) !== -1);
    }

    if (this.filterQty !== '') {
      this.MerchandiseList = this.MerchandiseList.filter((ele) => ele.Quantity.toString().indexOf(this.filterQty.toString()) !== -1);
    }

    if (this.filterDiscount !== '') {
      this.MerchandiseList = this.MerchandiseList.filter((ele) => ele.DiscountName.toLowerCase().indexOf(this.filterDiscount.toLowerCase()) !== -1);
    }

    if (this.filterPrice !== '') {
      let res = this.filterPrice.charAt(0);
      let filterItem;
      if (res == '$') {
        filterItem = this.filterPrice.slice(1);
      } else {
        filterItem = this.filterPrice;
      }
      this.MerchandiseList = this.MerchandiseList.filter((ele) => parseFloat(ele.TenantPrice).toFixed(2).toString().indexOf(filterItem.toString()) !== -1);
    }

    if (this.filterMerchandiseName === '' && this.filterStock === '' && this.filterQty === ''
      && this.filterDiscount === '' && this.filterPrice === '') {
      this.MerchandiseList = JSON.parse(JSON.stringify(this.masterMerchandiseListForFilter));
    }
  }
}
